(function(){
  const ROOT='[data-rpd-bundle-summary]';
  const GV='[data-grouped-variants-root]';
  const OPT='.js-optional';
  const STORAGE_PREFIX='rpd_bundle_state__';

  const ADVANCED_ENDPOINT='/apps/forus-promotions/advanced-discounts';
  let advancedConfigPromise=null;

  const NOVEMBER_PREVIEW_TOKENS={
    'faber:pro-deluxe-slot-plast':{percentage:10,contexts:{upgrade:12.5,'upgrade-pods':15,full:20}},
    'faber:slot-inox':{percentage:5,contexts:{upgrade:7.5,'upgrade-pods':8.5,full:10}},
    'faber:gamma-3':{percentage:3,contexts:{upgrade:5,'upgrade-pods':5,full:5}},
    'faber:coffee':{percentage:20,contexts:{bundle:30}},
    'faber:accessory':{percentage:10,contexts:{bundle:20}}
  };

  function isThemePreview(){
    return !!(document.getElementById('PBarNextFrame')||document.documentElement.classList.contains('shopify-design-mode')||window.Shopify?.designMode);
  }
  async function previewFallback(tokens){
    if(Object.keys(tokens||{}).length)return tokens;
    for(let attempt=0;attempt<20;attempt+=1){
      if(isThemePreview())return NOVEMBER_PREVIEW_TOKENS;
      await new Promise(resolve=>window.setTimeout(resolve,50));
    }
    return {};
  }

  const num=v=>{const n=Number(v);return Number.isFinite(n)?n:0};
  const clean=s=>String(s||'').toLowerCase().trim();
  const list=s=>String(s||'').split(',').map(x=>clean(x)).filter(Boolean);
  const money=(c)=>{
    const cents=Math.round(Number(c)||0);
    const locale=(document.documentElement.lang||'it-IT').replace('_','-')||'it-IT';
    try{
      return new Intl.NumberFormat(locale,{
        style:'currency',
        currency:'EUR',
        currencyDisplay:'symbol',
        minimumFractionDigits:2,
        maximumFractionDigits:2
      }).format(cents/100).replace(/\s*EUR\b/g,'').trim();
    }catch(e){
      return '€'+(cents/100).toFixed(2).replace('.',',');
    }
  };


  function percentText(value){
    const n=Math.round((Number(value)||0)*10)/10;
    const txt=Number.isInteger(n)?String(n):n.toFixed(1);
    const lang=(document.documentElement.lang||'').toLowerCase();
    return lang.startsWith('it')?txt.replace('.',','):txt;
  }
  function currencyTextToCents(txt){
    const s=String(txt||'');
    const matches=s.match(/(?:€\s*)?\d{1,4}(?:[\.\s]\d{3})*(?:[,.]\d{2})(?:\s*€)?/g);
    if(!matches||!matches.length)return 0;
    const raw=matches[0].replace(/€/g,'').replace(/\s/g,'').trim();
    let norm=raw;
    if(raw.includes(',')&&raw.includes('.'))norm=raw.replace(/\./g,'').replace(',','.');
    else if(raw.includes(','))norm=raw.replace(',','.');
    const n=Number(norm);
    return Number.isFinite(n)?Math.round(n*100):0;
  }

  function getGV(){return document.querySelector(GV)}
  function getForm(){return document.querySelector('product-form-component form[action*="/cart/add"], form[action*="/cart/add"]')}
  function getVariantId(root){return String(getGV()?.dataset.currentVariantId||getForm()?.querySelector('[name="id"]')?.value||root?.dataset.currentVariantId||'')}
  function getHandle(root){return String(getGV()?.dataset.currentHandle||root?.dataset.productHandle||'')}
  function getGroup(root){
    const g=clean(getGV()?.dataset.groupCollectionHandle||root?.dataset.groupHandle||'');

    // Slot collections/products have existed with more than one handle spelling.
    // Normalize all known aliases to the family keys used by the bundle config.
    if([
      'slot-plast-lite',
      'slot-plast-2-0',
      'slot-plast-2'
    ].includes(g))return 'slot-plast-2';

    if([
      'slot-inox-lite',
      'slot-inox-2-0',
      'slot-inox-2'
    ].includes(g))return 'slot-inox-2';

    return g;
  }
  function getQty(){const el=getForm()?.querySelector('[name="quantity"]')||document.querySelector('quantity-selector input,[name="quantity"]');const q=num(el?.value||1);return q>0?q:1}
  function hasUpgrade(){
    const g=getGV();
    if(!g)return false;
    // A selected upgrade can be disabled because the grouped configurator locks
    // options already included in the current variant. It is still part of the
    // machine and must therefore unlock the correct discount tier.
    return Array.from(g.querySelectorAll('[data-role="upgrade-options"] input[type="checkbox"], [data-role="upgrade-options"] input[type="radio"]')).some(i=>i.checked);
  }
  function config(root){try{return JSON.parse(root.querySelector('[data-rpd-config]')?.textContent||'{}')}catch(e){return {}}}
  function normalizeFamily(f, group){
    if(!f)return f;
    const g=clean(group);
    // V7.3: Pro Inox 3.0 e Pro Essential 3.0 devono seguire la nuova logica Pro Deluxe 3.0.
    // Se il blocco nel theme editor ha ancora i vecchi valori salvati (0 / 2.5 / 3.5 / 5),
    // li normalizziamo runtime senza toccare eventi, click o selezione optional.
    const isOtherPro3 = ['pro-total-inox-3-0','pro-essential-3-0'].includes(g);
    if(isOtherPro3){
      const copy=Object.assign({},f);
      if(num(copy.catalogDiscount)===0)copy.catalogDiscount=3;
      if(num(copy.upgradeDiscount)===2.5||num(copy.upgradeDiscount)===0)copy.upgradeDiscount=5;
      if(num(copy.upgradePodsDiscount)===3.5||num(copy.upgradePodsDiscount)===0)copy.upgradePodsDiscount=5;
      if(num(copy.fullDiscount)===0)copy.fullDiscount=5;
      return copy;
    }
    return f;
  }
  function family(cfg,group){
    const g=clean(group);
    const families=cfg.families||{};

    /*
     * Slot Inox deve usare la stessa curva sconto della Slot Plast,
     * anche se nel Theme Editor sono ancora salvati valori differenti.
     */
    if(g==='slot-inox-2'&&families.slotPlast){
      return normalizeFamily(Object.assign({},families.slotPlast),g);
    }

    for(const k of Object.keys(families)){
      const f=families[k]||{};
      if(list(f.handles).includes(g))return normalizeFamily(f,g);
    }

    return normalizeFamily(null,g);
  }

  function parseItalianSchedule(value){
    const m=String(value||'').trim().match(/^(\\d{4})-(\\d{2})-(\\d{2})[ T](\\d{2}):(\\d{2})$/);
    if(!m)return null;
    // October 2026 is CEST (UTC+2); convert the merchant-entered Italian clock time to UTC.
    return Date.UTC(Number(m[1]),Number(m[2])-1,Number(m[3]),Number(m[4])-2,Number(m[5]));
  }
  function isFaberDays(root){
    const box=document.querySelector('[data-rpd-price-container][data-rpd-kind="machine"]');
    const mode=clean(box?.dataset.rpdFaberDaysMode||'off');
    if(mode==='on')return true;
    if(mode!=='schedule')return false;
    const start=parseItalianSchedule(box?.dataset.rpdFaberDaysStart);
    const end=parseItalianSchedule(box?.dataset.rpdFaberDaysEnd);
    if(start===null||end===null||end<=start)return false;
    const now=Date.now();
    return now>=start&&now<end;
  }
  function faberDaysFixedCents(root){
    if(!isFaberDays(root))return 0;
    const box=document.querySelector('[data-rpd-price-container][data-rpd-kind="machine"]');
    if(box?.dataset.rpdFaberDaysEligible!=='true')return 0;
    const cents=Number(box?.dataset.rpdFaberDaysDiscountCents||0);
    return Number.isFinite(cents)&&cents>0?Math.round(cents):0;
  }

  function promoTokenForGroup(group){
    const g=clean(group);
    if(['pro-deluxe-2-0','slot-plast-2','slot-plast-2-0','slot-plast-lite'].includes(g))return 'faber:pro-deluxe-slot-plast';
    if(['slot-inox-2','slot-inox-2-0','slot-inox-lite'].includes(g))return 'faber:slot-inox';
    if(['pro-deluxe-3-0','pro-total-inox-3-0','pro-essential-3-0'].includes(g))return 'faber:gamma-3';
    return '';
  }
  function bundleContext(upgraded,addons){
    if(!upgraded)return 'base';
    const pods=hasType(addons,'pods150');
    const acc=hasType(addons,'accessory');
    if(pods&&acc)return 'full';
    if(pods)return 'upgrade-pods';
    return 'upgrade';
  }
  async function advancedTokens(){
    if(!advancedConfigPromise){
      advancedConfigPromise=fetch(ADVANCED_ENDPOINT,{credentials:'same-origin',headers:{Accept:'application/json'}})
        .then(r=>r.ok?r.json():Promise.reject(new Error('Advanced Discount config HTTP '+r.status)))
        .then(j=>previewFallback(j?.tokens||{}))
        .catch(err=>{console.warn('[RPD Faber] Advanced Discount config unavailable',err);advancedConfigPromise=null;return {}});
    }
    return advancedConfigPromise;
  }
  function tokenRate(tokens,token,context){
    const cfg=tokens?.[clean(token)];
    if(!cfg)return 0;
    const contextual=Number(cfg?.contexts?.[clean(context)]);
    if(Number.isFinite(contextual)&&contextual>0)return contextual;
    const base=Number(cfg?.percentage);
    return Number.isFinite(base)&&base>0?base:0;
  }

  function optionalType(input,item){
    const text=clean([input.dataset.title,input.dataset.productTitle,input.dataset.productType,input.dataset.sku,input.dataset.productSku,input.dataset.addonType,input.dataset.rpdType,item?.textContent].filter(Boolean).join(' '));
    let type=clean(input.dataset.addonType||input.dataset.rpdType||'');
    if(type)return type;
    // Priorità agli accessori espliciti: termini come "portacialda" contengono
    // "ciald", quindi DEVONO essere classificati prima del controllo caffè.
    if(
      text.includes('barmat')||
      text.includes('bar mat')||
      text.includes('365x220')||
      text.includes('bottiglia')||
      text.includes('vetro')||
      text.includes('cavo')||
      text.includes('svizzera')||
      text.includes('swiss')||
      text.includes('portacialda')||
      text.includes('porta cialda')||
      text.includes('porta-cialda')||
      text.includes('pod holder')||
      text.includes('podholder')||
      text.includes('beccuccio')||
      text.includes('accessor')||
      text.includes('manutenzione')||
      text.includes('maintenance')
    )return 'accessory';

    if(
      text.includes('ciald')||
      text.includes('caff')||
      text.includes('caffe')||
      text.includes('coffee')||
      text.includes('150 pz')||
      text.includes('150pz')
    )return 'pods150';
    // Ogni altro optional di PDP viene trattato come accessorio.
    return 'accessory';
  }

  function optionalPrice(input,item){
    const direct=num(input.dataset.priceCents||input.dataset.variantPriceCents||input.dataset.price||input.dataset.variantPrice);
    if(direct>0)return direct;
    const priceNode=item?.querySelector('[data-rpd-optional-price],[data-optional-price],.product-optionals__price,.price,[class*="price"]');
    const fromNode=currencyTextToCents(priceNode?.textContent||'');
    if(fromNode>0)return fromNode;
    return currencyTextToCents(item?.textContent||'');
  }

  function optionalMeta(input){
    const item=input.closest('.product-optionals__item,label')||input.parentElement;
    const value=String(input.value||input.dataset.variantId||'');
    const type=optionalType(input,item);
    const price=optionalPrice(input,item);
    const title=input.dataset.title||item?.querySelector('.product-optionals__name,[data-rpd-optional-title]')?.textContent?.trim()||item?.textContent?.trim()||'';
    const catalog=type==='pods150'
      ? num(input.dataset.catalogDiscount||input.dataset.rpdCatalogDiscount||15)
      : 0;
    const bundle=type==='pods150'
      ? num(input.dataset.bundleDiscount||input.dataset.rpdBundleDiscount||20)
      : 0;
    input.dataset.rpdType=type;
    input.dataset.price=String(price);
    input.dataset.rpdCatalogDiscount=String(catalog);
    input.dataset.rpdBundleDiscount=String(bundle);
    return {id:value,type,price,title,catalog,bundle,input,item};
  }

  function selectedOptionals(){return Array.from(document.querySelectorAll(OPT+':checked:not(:disabled)')).map(optionalMeta).filter(o=>o.id)}
  function hasType(arr,type){return arr.some(a=>a.type===type||(type==='accessory'&&(a.type==='barmat'||a.type==='accessory')))}
  function machineDiscount(tokens,group,upgraded,addons){
    return tokenRate(tokens,promoTokenForGroup(group),bundleContext(upgraded,addons));
  }
  function addonDiscount(tokens,addon,unlocked){
    const token=addon?.type==='pods150'?'faber:coffee':'faber:accessory';
    return tokenRate(tokens,token,unlocked?'bundle':'standalone');
  }
  async function machinePrice(root){const gv=getGV();const fromGv=num(gv?.dataset.currentPrice);if(fromGv)return fromGv;const pc=document.querySelector('[data-rpd-price-container]');const fromPc=num(pc?.dataset.rpdBaseCents);if(fromPc)return fromPc;return num(root.dataset.currentPrice)}
  function storageKey(root){return STORAGE_PREFIX+(root.dataset.productHandle||getHandle(root)||location.pathname)}
  function saveState(root){const data={variantId:getVariantId(root),handle:getHandle(root),optionals:Array.from(document.querySelectorAll(OPT+':checked')).map(i=>String(i.value)),ts:Date.now()};try{localStorage.setItem(storageKey(root),JSON.stringify(data))}catch(e){}}
  function restoreState(root){try{const data=JSON.parse(localStorage.getItem(storageKey(root))||'{}');if(!data||!Array.isArray(data.optionals))return;document.querySelectorAll(OPT).forEach(i=>{if(data.optionals.includes(String(i.value)))i.checked=true})}catch(e){}}
  async function getCart(){try{const r=await fetch('/cart.js',{credentials:'same-origin'});return r.ok?await r.json():null}catch(e){return null}}
  function setText(root,sel,text){root.querySelectorAll(sel).forEach(el=>{el.textContent=text})}

  function updatePriceLiquid(state){
    document.querySelectorAll('[data-rpd-price-container]').forEach(box=>{
      // V7.3.2: never update product cards/listing prices from the PDP bundle runtime.
      // Cards are rendered server-side by snippets/price.liquid with catalog discounts only.
      if(box.dataset.rpdContext==='card')return;
      if(box.dataset.rpdKind!=='machine')return;
      const original=box.querySelector('[data-rpd-price-original]');
      const final=box.querySelector('[data-rpd-price-final]');
      const badge=box.querySelector('[data-rpd-price-badge]');
      // The main PDP price belongs to the machine only. Bundle add-ons are
      // displayed in the configuration summary and must not be folded into
      // the product price or its percentage badge.
      const hasRealDiscount=Number(state.machineFinal)<Number(state.machineOriginal);
      if(original){
        original.textContent=money(state.machineOriginal,state.moneyFormat);
        original.style.display=hasRealDiscount?'':'none';
        original.style.visibility='';
        original.removeAttribute('data-rpd-price-cloak');
      }
      if(final)final.textContent=money(state.machineFinal,state.moneyFormat);
      if(badge){
        badge.textContent=hasRealDiscount
          ?(state.faberDaysActive
            ?'Faber Days -'+money(state.fixedMachineDiscountCents,state.moneyFormat)
            :(state.hasAnyAddon
              ?'Bundle -'+percentText(state.machineDiscount)+'%'
              :'-'+percentText(state.machineDiscount)+'%'))
          :'';
        badge.style.display=badge.textContent?'':'none';
      }
      box.dataset.rpdCurrentDiscount=String(state.machineDiscount);
      box.dataset.rpdTotalOriginal=String(state.totalOriginal);
      box.dataset.rpdTotalFinal=String(state.totalFinal);
      box.classList.add('is-rpd-price-ready');
    });
  }

  function syncOptionalCards(tokens,unlocked,cartIds){
    document.querySelectorAll(OPT).forEach(input=>{
      const meta=optionalMeta(input);const item=meta.item;if(!item)return;
      item.classList.toggle('is-rpd-selected',!!input.checked);
      item.classList.toggle('is-rpd-in-cart',cartIds.has(String(input.value)));
      const discount=addonDiscount(tokens,meta,unlocked);
      const disc=item.querySelector('[data-rpd-addon-discount]');
      if(disc)disc.textContent='-'+discount+'%';

      const priceBox=item.querySelector('.product-optionals__price,[data-rpd-optional-price],[data-optional-price]');
      if(priceBox&&meta.price>0){
        let original=priceBox.querySelector('[data-rpd-optional-price-original]');
        let final=priceBox.querySelector('[data-rpd-optional-price-final]');
        if(!original||!final){
          priceBox.textContent='';
          original=document.createElement('span');
          original.dataset.rpdOptionalPriceOriginal='';
          original.className='product-optionals__price-original';
          final=document.createElement('span');
          final.dataset.rpdOptionalPriceFinal='';
          final.className='product-optionals__price-final';
          priceBox.append(original,final);
        }
        const discounted=Math.max(0,Number(discount)||0)>0;
        const finalCents=discounted?Math.round(meta.price*(1-discount/100)):meta.price;
        original.textContent=money(meta.price);
        original.hidden=!discounted;
        final.textContent=money(finalCents);
        priceBox.classList.toggle('is-rpd-discounted',discounted&&finalCents<meta.price);
      }
    });
  }

  async function update(root){
    if(isFaberDays(root)){
      root.style.display='none';
      document.dispatchEvent(new CustomEvent('rpd:faber-days:refresh',{bubbles:true}));
      return null;
    }
    root.style.display='';
    const cfg=config(root), fmt=root.dataset.moneyFormat||'', group=(getGroup(root)||clean(document.querySelector('[data-rpd-price-container]')?.dataset.rpdGroupHandle||''));
    const faberDaysCents=0;
    const faberDaysActive=false;
    const tokens=faberDaysActive?{}:await advancedTokens();
    const upgraded=hasUpgrade();
    const addons=selectedOptionals();
    const mPrice=await machinePrice(root); const q=getQty();
    const mPct=faberDaysActive?0:machineDiscount(tokens,group,upgraded,addons);
    let original=mPrice*q;
    let final=faberDaysActive
      ?Math.max(0,original-(faberDaysCents*q))
      :Math.round(original*(1-mPct/100));
    const machineOriginal=original, machineFinal=final;
    const unlocked=!!upgraded;
    for(const a of addons){
      if(!a.price)continue;
      original+=a.price;
      final+=faberDaysActive?a.price:Math.round(a.price*(1-addonDiscount(tokens,a,unlocked)/100));
    }
    const hasPods=hasType(addons,'pods150'), hasAccessory=hasType(addons,'accessory');
    setText(root,'[data-rpd-machine-line]',faberDaysActive?'-'+money(faberDaysCents*q,fmt):'-'+String(mPct).replace('.0','')+'%');
    const coffees=addons.filter(a=>a.type==='pods150');
    const accessories=addons.filter(a=>a.type==='accessory'||a.type==='barmat');
    setText(root,'[data-rpd-coffee-line]',coffees.length?(faberDaysActive?'—':'-'+addonDiscount(tokens,coffees[0],unlocked)+'%'):'—');
    setText(root,'[data-rpd-accessory-line]',accessories.length?(faberDaysActive?'—':'-'+addonDiscount(tokens,accessories[0],unlocked)+'%'):'—');
    setText(root,'[data-rpd-original]',money(original,fmt));
    setText(root,'[data-rpd-final]',money(final,fmt));
    const saving=Math.max(0,original-final);
    setText(root,'[data-rpd-saving]',money(saving,fmt));
    root.querySelectorAll('[data-rpd-summary-saving-badge]').forEach(el=>{
      const prefix=el.dataset.rpdSummarySavingPrefix||'Risparmi';
      el.textContent=prefix+' '+money(saving,fmt);
    });
    root.querySelector('[data-rpd-status-machine]')?.classList.add('is-complete');
    root.querySelector('[data-rpd-status-upgrade]')?.classList.toggle('is-complete',upgraded);
    root.querySelector('[data-rpd-status-coffee]')?.classList.toggle('is-complete',hasPods);
    root.querySelector('[data-rpd-status-accessory]')?.classList.toggle('is-complete',hasAccessory);
    const msg=root.querySelector('[data-rpd-message]');
    if(msg){if(!upgraded)msg.textContent=cfg.labels?.missingUpgrade||msg.dataset.default||'';else if(!hasPods)msg.textContent=cfg.labels?.missingCoffee||'';else if(!hasAccessory)msg.textContent=cfg.labels?.missingAccessory||'';else msg.textContent=cfg.labels?.complete||''}
    const state={
      machineDiscount:mPct,
      fixedMachineDiscountCents:faberDaysActive?faberDaysCents:0,
      faberDaysActive,
      suppressAdvanced:faberDaysActive,
      promoToken:faberDaysActive?'':promoTokenForGroup(group),
      promoContext:faberDaysActive?'':bundleContext(upgraded,addons),
      coffeeDiscount:tokenRate(tokens,'faber:coffee',unlocked?'bundle':'standalone'),
      accessoryDiscount:tokenRate(tokens,'faber:accessory',unlocked?'bundle':'standalone'),
      machineOriginal,
      machineFinal,
      totalOriginal:original,
      totalFinal:final,
      totalSaving:Math.max(0,original-final),
      hasUpgrade:upgraded,
      hasPods,
      hasAccessory,
      hasAnyAddon:addons.length>0,
      addons,
      moneyFormat:fmt,
      variantId:getVariantId(root),
      productHandle:getHandle(root),
      groupHandle:group
    };
    // V7.4 line-properties architecture: expose the already-calculated bundle state.
    // The add-to-cart layer uses this as source of truth and passes explicit cart line
    // attributes/properties to the Shopify Function. The Function must not reconstruct
    // upgrades or bundle state from SKU lists anymore.
    window.__faberRpdBundleState=state;
    updatePriceLiquid(state); saveState(root); document.dispatchEvent(new CustomEvent('rpd:bundle:update',{bubbles:true,detail:state}));
    return state;
  }

  async function refreshCartStatus(root){
    const cart=await getCart();
    const ids=new Set((cart?.items||[]).map(i=>String(i.variant_id)));
    const current=ids.has(String(getVariantId(root)));
    const selected=selectedOptionals();
    const selectedInCart=selected.filter(a=>ids.has(String(a.id))).length;
    const msg=root.querySelector('[data-rpd-cart-status]');
    if(msg){if(current&&selectedInCart)msg.textContent='Configurazione già presente nel carrello.';else if(current)msg.textContent='Macchina già presente nel carrello.';else msg.textContent='';msg.hidden=!msg.textContent}
    syncOptionalCards(await advancedTokens(),hasUpgrade(),ids);
  }

  function bind(root){
    if(root.dataset.rpdBound==='1')return;root.dataset.rpdBound='1';restoreState(root);

    // Public refresh hook for the add-to-cart layer.
    // It returns the exact state calculated by this runtime, so cart properties
    // always match the percentages currently shown in the PDP summary.
    window.__faberRpdBundleRefresh = async () => {
      const freshState = await update(root);
      return freshState;
    };

    const run=()=>update(root).then(()=>refreshCartStatus(root));
    document.addEventListener('change',e=>{if(e.target.matches(OPT)||e.target.closest?.('[data-role="upgrade-options"]')||e.target.matches?.('[name="quantity"]'))setTimeout(run,80)});
    document.addEventListener('click',e=>{if(e.target.closest?.(GV))setTimeout(run,250)});
    const g=getGV();if(g)new MutationObserver(run).observe(g,{attributes:true,attributeFilter:['data-current-variant-id','data-current-handle','data-group-collection-handle']});
    document.addEventListener('cart:update',()=>setTimeout(()=>refreshCartStatus(root),100));
    document.addEventListener('grouped:before-entry-apply',()=>setTimeout(run,40));
    document.addEventListener('grouped:entry-applied',()=>setTimeout(run,80));
    // Fired after the grouped configurator has reconstructed the current
    // variant, including upgrades already present on direct PDP landing.
    document.addEventListener('grouped:availability-change',()=>setTimeout(run,0));
    document.addEventListener('rpd:bundle:added',()=>setTimeout(()=>refreshCartStatus(root),150));
    run();
  }
  function init(){document.querySelectorAll(ROOT).forEach(bind);document.querySelectorAll('[data-rpd-price-container]').forEach(box=>{if(box.dataset.rpdKind!=='machine')return;const root=document.querySelector(ROOT);if(root)update(root)})}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);document.addEventListener('variant:update',()=>setTimeout(init,80));
})();
